namespace NasVault {
  export async function load(path = "/"): Promise<void> {
    if (state.loading) return;
    state.loading = true;
    setStatus("불러오는 중…");
    renderSkeleton();
    try {
      const data = await api.list(path);
      if (!data.ok) throw new Error(data.error || "목록을 불러오지 못했어요.");
      state.currentPath = data.path || path;
      state.canWrite = data.canWrite === true;
      state.deleteEnabled = data.deleteEnabled === true;
      const items = data.items || [];
      if (state.currentPath === "/") state.rootFolders = items.filter((item) => item.type === "folder");
      const pathNode = element("nasPath");
      if (pathNode) pathNode.textContent = state.currentPath;
      renderWriteAvailability();
      renderSidebar();
      renderBreadcrumbs(state.currentPath);
      renderFiles(items);
      setStatus("");
      state.loaded = true;
    } catch (error) {
      state.canWrite = false;
      state.deleteEnabled = false;
      state.loaded = false;
      renderWriteAvailability();
      setStatus(error instanceof Error ? error.message : "NAS에 연결할 수 없어요.", true);
      renderFiles([]);
    } finally {
      state.loading = false;
    }
  }

  function bindDragAndDrop(): void {
    const dropZone = element("nasDropZone");
    dropZone?.addEventListener("dragenter", (event) => {
      event.preventDefault();
      if (!state.canWrite) {
        state.dragDepth = 0;
        dropZone.classList.remove("dragging");
        return;
      }
      state.dragDepth += 1;
      dropZone.classList.add("dragging");
    });
    dropZone?.addEventListener("dragover", (event) => {
      event.preventDefault();
      if (!state.canWrite) {
        state.dragDepth = 0;
        dropZone.classList.remove("dragging");
        if (event.dataTransfer) event.dataTransfer.dropEffect = "none";
        return;
      }
      if (event.dataTransfer) event.dataTransfer.dropEffect = "copy";
    });
    dropZone?.addEventListener("dragleave", () => {
      state.dragDepth = Math.max(0, state.dragDepth - 1);
      if (!state.dragDepth) dropZone.classList.remove("dragging");
    });
    dropZone?.addEventListener("drop", (event) => {
      event.preventDefault();
      state.dragDepth = 0;
      dropZone.classList.remove("dragging");
      if (!state.canWrite) return;
      requestUpload(Array.from(event.dataTransfer?.files || []));
    });
  }

  function bindToolbar(): void {
    element("nasRefresh")?.addEventListener("click", () => void load(state.currentPath));
    element("nasNewFolder")?.addEventListener("click", async () => {
      if (!state.canWrite) {
        setStatus("이 폴더에는 새 폴더를 만들 수 없어요.", true);
        return;
      }
      const name = prompt("새 폴더 이름");
      if (!name) return;
      try {
        await api.createFolder(joinPath(state.currentPath, name));
        setStatus(`${name} 폴더를 만들었어요.`);
        await load(state.currentPath);
      } catch (error) {
        setStatus(error instanceof Error ? error.message : "폴더를 만들지 못했어요.", true);
      }
    });
    element<HTMLInputElement>("nasUpload")?.addEventListener("change", (event) => {
      const input = event.target as HTMLInputElement;
      requestUpload(Array.from(input.files || []));
      input.value = "";
    });
  }

  export function init(): void {
    renderWriteAvailability();
    bindToolbar();
    bindDragAndDrop();
    bindUploadDialog();
    bindDeleteDialog();
    if (typeof router !== "undefined") {
      router.registerViewEnter((view) => {
        if (view === "nas" && !state.loaded) void load("/");
      });
    }
  }
}

document.addEventListener("DOMContentLoaded", NasVault.init);
